import React from "react";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "351928272818";
const WHATSAPP_MESSAGE = "Ola Veentto, quero saber mais sobre o programa B2B para revendedores.";

const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar com a Veentto no WhatsApp"
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 inline-flex h-14 w-14 items-center justify-center bg-[#25D366] text-black brut-border brut-btn"
    >
      <MessageCircle size={28} strokeWidth={2.5} />
    </a>
  );
};

export default WhatsAppButton;
